// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"7b801028","637":"5eb3754b"}[chunkId] + ".chunk.js";
};